// extracted by mini-css-extract-plugin
export default {"flexed":"styles_flexed__TmBVu"};